module.exports = __webpack_public_path__ + "img/pic2.0879f861.jpeg";